/**
 * Correspondance entre les types de permis et les types de véhicules autorisés
 * Basé sur la réglementation française des permis de conduire
 */

export type LicenseType = "B" | "C" | "D" | "E";
export type VehicleType =
  | "vul"               // Véhicule Utilitaire Léger (< 3.5t)
  | "pl_fourgon"        // PL Porteur Fourgon
  | "pl_citerne"        // PL Porteur Citerne
  | "pl_plateau"        // PL Porteur Plateau
  | "tracteur_routier"  // Tracteur routier
  | "semi_fourgon"      // Semi-remorque Fourgon
  | "semi_citerne"      // Semi-remorque Citerne
  | "semi_plateau"      // Semi-remorque Plateau
  | "remorque_fourgon"  // Remorque Fourgon
  | "remorque_citerne"  // Remorque Citerne
  | "remorque_plateau"  // Remorque Plateau
  | "vl_autocar";       // VL / Autocar

/**
 * Mapping des permis vers les types de véhicules autorisés
 */
export const LICENSE_VEHICLE_MAPPING: Record<LicenseType, VehicleType[]> = {
  B: ["vul", "vl_autocar"],
  C: ["vul", "pl_fourgon", "pl_citerne", "pl_plateau", "vl_autocar"],
  D: ["vul", "vl_autocar"],
  E: ["vul", "pl_fourgon", "pl_citerne", "pl_plateau", "tracteur_routier", "semi_fourgon", "semi_citerne", "semi_plateau", "remorque_fourgon", "remorque_citerne", "remorque_plateau", "vl_autocar"],
};

/**
 * Vérifie si un chauffeur peut conduire un type de véhicule donné
 */
export function canDriverOperateVehicle(
  licenseType: LicenseType,
  vehicleType: VehicleType | undefined
): boolean {
  if (!vehicleType) return true;
  const allowedTypes = LICENSE_VEHICLE_MAPPING[licenseType];
  return allowedTypes?.includes(vehicleType) ?? false;
}

/**
 * Labels français pour les types de véhicules
 */
export const VEHICLE_TYPE_LABELS: Record<VehicleType, string> = {
  vul: "VUL - Utilitaire Léger",
  pl_fourgon: "PL Porteur Fourgon",
  pl_citerne: "PL Porteur Citerne",
  pl_plateau: "PL Porteur Plateau",
  tracteur_routier: "Tracteur Routier",
  semi_fourgon: "Semi-remorque Fourgon",
  semi_citerne: "Semi-remorque Citerne",
  semi_plateau: "Semi-remorque Plateau",
  remorque_fourgon: "Remorque Fourgon",
  remorque_citerne: "Remorque Citerne",
  remorque_plateau: "Remorque Plateau",
  vl_autocar: "VL / Autocar",
};

/**
 * Labels courts pour les types de véhicules
 */
export const VEHICLE_TYPE_SHORT_LABELS: Record<VehicleType, string> = {
  vul: "VUL",
  pl_fourgon: "PL Fourgon",
  pl_citerne: "PL Citerne",
  pl_plateau: "PL Plateau",
  tracteur_routier: "Tracteur",
  semi_fourgon: "Semi Fourgon",
  semi_citerne: "Semi Citerne",
  semi_plateau: "Semi Plateau",
  remorque_fourgon: "Rem. Fourgon",
  remorque_citerne: "Rem. Citerne",
  remorque_plateau: "Rem. Plateau",
  vl_autocar: "VL/Autocar",
};

/**
 * Labels français pour les types de permis
 */
export const LICENSE_TYPE_LABELS: Record<LicenseType, string> = {
  B: "Permis B - Véhicules légers",
  C: "Permis C - Poids lourds",
  D: "Permis D - Transport de personnes",
  E: "Permis E - Véhicules articulés",
};













